import { Color } from 'components/colors';

export const durationOptions = [
  { label: '1 week', value: 1 },
  { label: '2 weeks', value: 2 },
  { label: '3 weeks', value: 3 },
  { label: '4 weeks', value: 4 },
  { label: 'custom', value: 0 },
] as const;

export const SPRINT_IN_TEMPLATE_DURATION_MULTIPLE = 5;

export const DEFAULT_STATUS = {
  label: 'To do',
  group: 1,
  color: 'blue' as Color,
};
